// get all categories
export const categoriesQuery = `*[_type == "category"]{
    _id,
    title,
    slug
}`

// get a single category by its slug
export const categoryQuery = `*[_type == "category" && slug.current == $slug][0]{
    _id,
    title,
    slug,
    description
}`